import { createTheme } from '@material-ui/core/styles';

import typography from './typography'
import palette from './palette';

const theme = createTheme({
  typography,
  spacing: 4,
  palette
});

export default theme;
